<template>
  <!-- using vuetify's generic component v-input is handy for homogeneous labels, validation, etc. -->
  <v-input
    :name="fullKey"
    :label="label"
    :disabled="disabled"
    :rules="rules"
    :required="required"
    v-model="items"
  >
    <div>
      <v-data-table :headers="headers" :items="items">
        <template v-for="(h, i) in headers" v-slot:[`item.${h.value}`]="props">
          <v-edit-dialog
            :key="i"
            @save="save(props.item, h.value)"
            @cancel="cancel"
            @open="open(props.item, h.value)"
            @close="close"
          >
            {{ props.item[`${h.value}`] }}
            <template v-slot:input>
              <v-text-field
                v-model="editValue"
                :rules="[max25chars]"
                label="Edit"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <!-- <template v-slot:[`item.name`]="props">
          <v-edit-dialog
            :return-value.sync="props.item.name"
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
          >
            {{ props.item.name }}
            <template v-slot:input>
              <v-text-field
                v-model="props.item.name"
                :rules="[max25chars]"
                label="Edit"
                single-line
                counter
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:[`item.iron`]="props">
          <v-edit-dialog
            :return-value.sync="props.item.iron"
            large
            persistent
            @save="save"
            @cancel="cancel"
            @open="open"
            @close="close"
          >
            <div>{{ props.item.iron }}</div>
            <template v-slot:input>
              <div class="mt-4 text-h6">Update Iron</div>
              <v-text-field
                v-model="props.item.iron"
                :rules="[max25chars]"
                label="Edit"
                single-line
                counter
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template> -->
      </v-data-table>

      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-input>
</template>

<script>
export default {
  components: {},
  // available props are the contextual elements passed by v-jsf to its slots
  props: {
    value: { type: String, default: "" },
    options: { type: Object, required: true },
    schema: { type: Object, required: true },
    fullSchema: { type: Object, required: true },
    fullKey: { type: String, required: true },
    label: { type: String, default: "" },
    htmlDescription: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, required: true },
    on: { type: Object, required: true },
  },
  data() {
    return {
      snack: false,
      snackColor: "",
      snackText: "",
      max25chars: (v) => v.length <= 25 || "Input too long!",
      pagination: {},
      editValue: "",
    };
  },

  // TODO: Dynamic rules

  computed: {
    items() {
      return JSON.parse(this.value);
    },
    headers() {
      return this.options.context[`${this.fullSchema.headersDefPath}`];
    },
  },

  methods: {
    save(itm, col) {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";

      itm[`${col}`] = this.editValue;

      // console.log("save val", this.editValue, col);
      // console.log("save (input)", this.items);

      this.$emit("input", JSON.stringify(this.items));
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
      this.editValue = "";
    },
    open(itm, col) {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
      this.editValue = itm[`${col}`];
    },
    close() {
      this.editValue = "";
      console.log("Dialog closed");
    },
  },
};
</script>
